module.exports = __webpack_public_path__ + "static/media/illustration_header.70fd24f2.svg";